import {
  ParsedComment,
  ParsedCommentSegment
} from "@/jenesys-types/data/communication";
import { User } from "@/jenesys-types/jenesys-entities/config";

export const parseCommentText = (
  rawText: string,
  companyMembers: Array<User>
): ParsedComment => {
  const segments: Array<ParsedCommentSegment> = [];
  const mentions: Array<string> = [];

  const userMap = new Map<string, User>();
  companyMembers.forEach((member) => {
    const fullName = `${member.first_name} ${member.last_name}`.toLowerCase();
    userMap.set(fullName, member);
  });

  const safeRawText = typeof rawText === "string" ? rawText : "";

  // Split text by @ quoted mentions: @"Jack Hewitt"
  const parts = safeRawText.split(/(@"[^"]*")/g);

  parts.forEach((part) => {
    if (part.startsWith('@"') && part.endsWith('"')) {
      const username = part.substring(2, part.length - 1).toLowerCase();
      const user = userMap.get(username);

      if (user) {
        segments.push({
          type: "mention",
          content: part,
          userId: user.id,
          userName: `${user.first_name} ${user.last_name}`
        });
        mentions.push(user.id);
      } else {
        segments.push({
          type: "text",
          content: part
        });
      }
    } else if (part !== "") {
      segments.push({
        type: "text",
        content: part
      });
    }
  });

  return {
    rawText: safeRawText,
    segments,
    mentions
  };
};

export const serializeParsedComment = (parsedComment: ParsedComment): string =>
  parsedComment.rawText;

export const deserializeParsedComment = (rawText: string): ParsedComment => {
  const safeRawText = typeof rawText === "string" ? rawText : "";
  return {
    rawText: safeRawText,
    segments: [{ type: "text", content: safeRawText }],
    mentions: []
  };
};

export const extractMentions = (rawText: string): Array<string> => {
  const safeRawText = typeof rawText === "string" ? rawText : "";
  const mentions: Array<string> = [];
  const regex = /@"([^"]*)"/g;
  let match: RegExpExecArray | null = regex.exec(safeRawText);

  while (match !== null) {
    mentions.push(match[1]);
    match = regex.exec(safeRawText);
  }

  return mentions;
};
